import { render } from "./lyrsCard.vue?vue&type=template&id=8a6bf852&scoped=true"
import script from "./lyrsCard.vue?vue&type=script&lang=js"
export * from "./lyrsCard.vue?vue&type=script&lang=js"

import "./lyrsCard.vue?vue&type=style&index=0&id=8a6bf852&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a6bf852"]])

export default __exports__